import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const getRMConfigs = createAsyncThunk('alix/get-rm-config', async (payload, toolkit) => {
  return await AxiosClient('GET', `/v1/risk-management/system/config/react?industry=aeroSpace`, {}, toolkit)
})
